module.exports = __webpack_public_path__ + "img/bosnia-and-herzegovina.21a9ce1a.png";